import { render, staticRenderFns } from "./user-comment.vue?vue&type=template&id=054fa860&scoped=true&"
import script from "./user-comment.vue?vue&type=script&lang=js&"
export * from "./user-comment.vue?vue&type=script&lang=js&"
import style0 from "./user-comment.vue?vue&type=style&index=0&id=054fa860&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054fa860",
  null
  
)

export default component.exports